import * as types from '@/store/mutation-types';

const state = {
  activeDroplet: {},
  activeItems: [],
  activeDropletIndex: null,
  activeDropletItem: false,
  activeState: null,
  animationPreview: false,
  localStyle: {
    properties: [],
    value: null,
  },
  dropletObserver: false,
  showStyleSidebar: false,
  bouncePluginHook: false,
  styleConditionals: {},
};

const getters = {
  activeDroplet(state) {
    return state.activeDroplet;
  },
  activeItems(state) {
    return state.activeItems;
  },
  activeDropletIndex(state) {
    return state.activeDropletIndex;
  },
  activeDropletItem(state) {
    return state.activeDropletItem;
  },
  activeState(state) {
    return state.activeState;
  },
  animationPreview(state) {
    return state.animationPreview;
  },
  localStyle(state) {
    return state.localStyle;
  },
  showStyleSidebar(state) {
    return state.showStyleSidebar;
  },
  dropletObserver(state) {
    return state.dropletObserver;
  },
  bouncePluginHook(state) {
    return state.bouncePluginHook;
  },
  styleConditionals(state) {
    return state.styleConditionals;
  },
};

const mutations = {
  [types.SET_ACTIVE_DROPLET](state, { droplet, items, index }) {
    this._vm.$log.debug('SET_ACTIVE_DROPLET: ', droplet);
    this._vm.$set(state, 'activeDroplet', droplet);
    if (items) {
      this._vm.$set(state, 'activeItems', items);
    }
    if (typeof index !== 'undefined') {
      this._vm.$set(state, 'activeDropletIndex', index);
    }
  },
  [types.SET_ACTIVE_DROPLET_ITEM](state, p) {
    this._vm.$log.debug('SET_ACTIVE_DROPLET_ITEM: ', p);
    this._vm.$set(state, 'activeDropletItem', p);
  },
  [types.SET_ACTIVE_STATE](state, p) {
    state.activeState = p;
  },
  [types.SET_ANIMATION_PREVIEW](state, p) {
    state.animationPreview = p;
  },
  [types.SET_LOCAL_STYLES](state, p) {
    state.localStyle.properties = p.properties;
    state.localStyle.value = p.val;
  },
  [types.TOGGLE_STYLE_SIDEBAR](state, p) {
    state.showStyleSidebar = p;
  },
  [types.SET_DROPLET_OBSERVER](state, p) {
    state.dropletObserver = p;
  },
  [types.CALL_PLUGIN_BOUNCE](state, p) {
    state.bouncePluginHook = p;
  },
  [types.SET_STYLE_CONDITION](state, p) {
    const $vm = this._vm;
    if (!state.styleConditionals[p._id]) {
      $vm.$set(state.styleConditionals, p._id, {});
    }
    $vm.$set(state.styleConditionals[p._id], p.condition, p.value);
    $vm.$log.debug('SET_STYLE_CONDITION: ', state.styleConditionals);
  },
};

const unState = {
  timer: null,
};

const actions = {
  setActiveDroplet({ commit }, payload) {
    commit(types.SET_ACTIVE_DROPLET, payload);
  },
  setActiveDropletItem({ commit }, payload) {
    commit(types.SET_ACTIVE_DROPLET_ITEM, payload);
  },
  setActiveState({ commit }, payload) {
    commit(types.SET_ACTIVE_STATE, payload);
  },
  setAnimationPreview({ commit }) {
    commit(types.SET_ANIMATION_PREVIEW, true);
    clearTimeout(unState.timer);
    unState.timer = setTimeout(() => {
      commit(types.SET_ANIMATION_PREVIEW, false);
    }, 250);
  },
  setLocalStyles({ commit }, payload) {
    commit(types.SET_LOCAL_STYLES, payload);
  },
  setDropletObserver({ commit }, payload) {
    commit(types.SET_DROPLET_OBSERVER, payload);
  },
  toggleStyleSidebar({ commit }, payload) {
    commit(types.TOGGLE_STYLE_SIDEBAR, payload);
  },
  callPluginBounce({ commit }, payload) {
    commit(types.CALL_PLUGIN_BOUNCE, payload);
  },
  setStyleCondition({ commit }, payload) {
    commit(types.SET_STYLE_CONDITION, payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/style-sidebar/vuex.js